var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLinkArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "21px",
    viewBox: "0 0 12 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "functionality-button",
    transform: "translate(-372.000000, -824.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "knapp-hover",
    transform: "translate(150.000000, 799.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(109.000000, 25.500000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "114 0 124 10 114 20"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkArrowIcon);
export default __webpack_public_path__ + "static/media/nav-link-arrow-icon.5db7f7ebbad2f00697f0324b057d1b84.svg";
export { ForwardRef as ReactComponent };